
import { supabase } from "@/integrations/supabase/client";
import { AppRole } from "@/types/database/auth";
import { ExtendedRole } from "@/components/admin/employees/types";
import { useToast } from "@/hooks/use-toast";

export const useEmployeeRole = () => {
  const { toast } = useToast();

  const setUserRole = async (userId: string, role: ExtendedRole) => {
    try {
      // If role is 'client', convert it to 'user' for database compatibility
      const dbRole: AppRole = role === 'client' ? 'user' : role as AppRole;
      
      const { error } = await supabase
        .from('user_roles')
        .insert({
          user_id: userId,
          role: dbRole
        });

      if (error) throw error;
      return { success: true };
    } catch (error: any) {
      console.error("Error setting user role:", error);
      return { success: false, error };
    }
  };

  const updateUserRole = async (userId: string, role: ExtendedRole) => {
    try {
      // If role is 'client', convert it to 'user' for database compatibility
      const dbRole: AppRole = role === 'client' ? 'user' : role as AppRole;
      
      const { error } = await supabase
        .rpc('update_user_role_safely', {
          user_id_input: userId,
          new_role: dbRole
        });

      if (error) throw error;
      return { success: true };
    } catch (error: any) {
      console.error("Error updating user role:", error);
      return { success: false, error };
    }
  };

  return { setUserRole, updateUserRole };
};
